/** InsCoder WANG.J 2026-08-17 B + PDP See How It Wears - desktop drag-to-scroll **/
(function () {
  function initSeeHowItWearsDrag() {
    var scrollers = document.querySelectorAll('.cust-main-product-see-how-it-wears__videos');

    scrollers.forEach(function (scroller) {
      if (scroller.dataset.seeHowItWearsDragInitialized === 'true') return;
      scroller.dataset.seeHowItWearsDragInitialized = 'true';

      var wrapper = scroller.closest('.cust-main-product-see-how-it-wears__videos-wrapper');
      var isDown = false;
      var hasDragged = false;
      var startX = 0;
      var startScrollLeft = 0;

      scroller.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDown = true;
        hasDragged = false;
        startX = e.pageX;
        startScrollLeft = scroller.scrollLeft;
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 3) {
          hasDragged = true;
          scroller.classList.add('is-dragging');
        }
        if (hasDragged) {
          e.preventDefault();
          scroller.scrollLeft = startScrollLeft - dx;
        }
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
      }

      window.addEventListener('mouseup', endDrag);
      scroller.addEventListener('mouseleave', endDrag);

      // Suppress click after a real drag so videos/links are not triggered accidentally
      scroller.addEventListener('click', function (e) {
        if (hasDragged) {
          e.preventDefault();
          e.stopPropagation();
          hasDragged = false;
        }
      }, true);

      function updateScrollState() {
        if (!wrapper) return;
        var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 1;
        var isAtEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1;
        wrapper.classList.toggle('has-overflow', hasOverflow);
        wrapper.classList.toggle('is-at-end', !hasOverflow || isAtEnd);
      }

      scroller.addEventListener('scroll', updateScrollState, { passive: true });
      window.addEventListener('resize', updateScrollState);
      window.requestAnimationFrame(updateScrollState);
    });
  }

  function openSeeHowItWearsModal(e) {
    var button = e.target.closest('[data-see-how-it-wears-modal]');
    if (!button || e.defaultPrevented) return;

    var modal = document.querySelector(button.dataset.seeHowItWearsModal);
    if (!modal || typeof modal.show !== 'function') return;

    modal.show(button);
    window.requestAnimationFrame(function () {
      var video = modal.querySelector('.cust-main-product-see-how-it-wears__modal-video');
      if (!video) return;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSeeHowItWearsDrag);
  } else {
    initSeeHowItWearsDrag();
  }

  document.addEventListener('shopify:section:load', initSeeHowItWearsDrag);
  document.addEventListener('click', openSeeHowItWearsModal);
})();
/** InsCoder WANG.J 2026-08-17 E + PDP See How It Wears - desktop drag-to-scroll **/
